export var StreamingFilterBlockConstant = "streaming";
//# sourceMappingURL=filterBlockConstants.js.map